import {
  GetCategoryPageActiveCategoryBySanitizedPathDocument,
  type GetCategoryPageActiveCategoryBySanitizedPathQuery
} from '@stuller/stullercom/data-access/apollo-queries'
import { GetCategoryPageDocument, type GetCategoryPageQuery } from '@stuller/stullercom/data-access/apollo-queries-contentstack'
import { type CategoryPageType } from './types'

const getInitialProps: CategoryPageType['getInitialProps'] = async (context) => {
  const { apolloClient } = context
  const sanitizedPath = new URL(`https://${context.auth.host}${context.asPath}`)
    .pathname
    .toLowerCase()
    .replace(/\/$/, '')
    .replace(/\/next\b/, '')
    .replace(/\/browse\b\//, '')
  let categoryData: GetCategoryPageActiveCategoryBySanitizedPathQuery['activeCategoryBySanitizedPath'] | null = null

  const { data } = await apolloClient.query<GetCategoryPageActiveCategoryBySanitizedPathQuery>({
    query: GetCategoryPageActiveCategoryBySanitizedPathDocument,
    variables: { sanitizedPath }
  })

  categoryData = data.activeCategoryBySanitizedPath

  // 404 if category is not found or is not a content only category
  if (categoryData == null ||
    categoryData.displayTemplate !== 'ContentOnly'
  ) {
    return { statusCode: 404 }
  }

  // If there is a override url, redirect to it
  if (categoryData.overrideUrl != null) {
    return { statusCode: 302, location: categoryData.overrideUrl }
  }

  // Get CMS data
  const result = await apolloClient.query<GetCategoryPageQuery>({
    query: GetCategoryPageDocument,
    variables: { categoryId: categoryData.id },
    context: {
      contentstackLink: true
    }
  })
  const cmsData = result.data

  // 404 if category not found in CMS
  if (cmsData?.all_category_page?.items?.[0] == null) {
    return { statusCode: 404 }
  }

  return { cmsData, categoryData }
}

export {
  getInitialProps
}
